import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { ArticleComment } from "~/components/article/article-comment";
import { Spacer } from "~/components/common/spacer";
import type { CommentWidgetPosition } from "~/components/tracking/google-analytics-4/types";
import { formatDistanceToNow, toISOString } from "~/lib/utils";
import type { contentActionBarContent$key } from "~/queries/__generated__/contentActionBarContent.graphql";

import { FlexContainer, IconContainer, StyledContentBookmark, VideoIcon } from "./styles";

export type Props = {
  className?: string;
  isBookmarkVisible?: boolean;
  isCommentsVisible?: boolean;
  reference: contentActionBarContent$key;
  trackingPosition?: CommentWidgetPosition;
};

export const ContentActionBar: FunctionComponent<Props> = ({
  className,
  isBookmarkVisible = true,
  isCommentsVisible = true,
  reference: reference_,
  trackingPosition = "rail",
}) => {
  const content = useFragment(
    graphql`
      fragment contentActionBarContent on Content {
        entityId
        updatedDate
        urlAlias
        ...articleCommentArticle
        ... on Article {
          hasVideoContent
        }
      }
    `,
    reference_,
  );

  return (
    <FlexContainer className={className}>
      <time dateTime={toISOString(content.updatedDate as number)}>
        {formatDistanceToNow(content.updatedDate as number)}
      </time>
      {/*  Cspell:ignore videocam */}
      {content.hasVideoContent && (
        <VideoIcon color="#d7d7d7" size="20px">
          videocam
        </VideoIcon>
      )}
      <Spacer />
      <IconContainer>
        {isCommentsVisible && (
          <ArticleComment reference={content} trackingPosition={trackingPosition} />
        )}

        {isBookmarkVisible && (
          <StyledContentBookmark entityId={content.entityId} urlAlias={content.urlAlias} />
        )}
      </IconContainer>
    </FlexContainer>
  );
};

ContentActionBar.displayName = "ContentActionBar";
